import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { User } from "../../../../shared/models/user";
import { UserGroup } from "../../../../shared/models/user-group";
import { Session } from "../../../../services/session.service";
import {applicationType} from "../team-users.component";

@Component({
    selector: 'app-member-add',
    templateUrl: './member-add.component.html',
    styleUrls: ['./member-add.component.scss'],
    host: {
        '(document:click)': 'genericClick($event)',
    },
    standalone: false
})
export class MemberAddComponent implements OnInit {
  @Input() allUsers: userInfo[] = [];
  @Input() allTeamUsers: User[] = [];
  @Input() editMembers: User[] = [];
  @Input() readMembers: User[] = [];
  @Input() commentMembers: User[] = [];
  @Input() adminMembers: User[] = [];
  @Input() evalMembers: User[] = [];
  @Input() allAvailableGroups: UserGroup[] = [];
  @Input() editGroups: UserGroup[] = [];
  @Input() commentGroups: UserGroup[] = [];
  @Input() readGroups: UserGroup[] = [];
  @Input() projectLocked:boolean = false;
  @Input() applicationType: number = applicationType.assessment;
  @Output() addSignal: EventEmitter<User> = new EventEmitter<User>();
  @Output() addGroupSignal: EventEmitter<UserGroup> = new EventEmitter<UserGroup>();

  addExpanded: boolean = false;
  addUserExpanded: boolean = false;
  addGroupExpanded: boolean = false;

  canEditGroups:boolean = true;

  constructor(private session: Session) { }

  ngOnInit() {
    this.canEditGroups = this.session.getPermissionToShow.canCreateEditUsersUserGroups;
  }

  openAddUser() {
    this.addExpanded = false;
    this.addUserExpanded = true;
  }
  closeAddUser() {
    this.addUserExpanded = false;
  }
  addIndividual(member) {
    this.addExpanded = false;
    this.addUserExpanded = false;
    this.addSignal.emit(member);
  }

  openAddGroup() {
    this.addExpanded = false;
    this.addGroupExpanded = true;
  }
  closeAddGroup() {
    this.addGroupExpanded = false;
  }
  addGroup(group) {
    this.addExpanded = false;
    this.addGroupExpanded = false;
    this.addGroupSignal.emit(group);
  }

  genericClick(event) {
    if(!event.target.classList.contains('addTeamMemberBtn') && this.addExpanded === true){
      this.addExpanded = false;
    }
  }

}
interface userInfo {
  member: {
    profilePicture: string;
    id: number;
    name: string;
    firstName: string;
    lastName: string;
    requestKey: string;
  }
  isInstitutionAdmin: boolean;
}
